import { faClock } from "@fortawesome/pro-regular-svg-icons/faClock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Flex, Text, Tooltip } from "@mantine/core";

export const NotAsked = () => {
  return (
    <Tooltip
      label={
        <Text size="sm" c="black">
          The version of this screener the candidate completed didn’t include
          this question
        </Text>
      }
      multiline
      withArrow
      arrowSize={8}
      w={400}
      color="white"
      classNames={{ tooltip: "border border-gray-200 z-[1000]" }}
    >
      <Flex align="center" c="gray.7">
        <FontAwesomeIcon className="mr-1.5" icon={faClock} />
        <Text size="sm">Not asked</Text>
      </Flex>
    </Tooltip>
  );
};
